var map = {
	"./affix/style/index.tsx": 986,
	"./alert/style/index.tsx": 988,
	"./anchor/style/index.tsx": 990,
	"./auto-complete/style/index.tsx": 992,
	"./avatar/style/index.tsx": 997,
	"./back-top/style/index.tsx": 999,
	"./badge/style/index.tsx": 1001,
	"./breadcrumb/style/index.tsx": 1003,
	"./button/style/index.tsx": 186,
	"./calendar/style/index.tsx": 1005,
	"./card/style/index.tsx": 1008,
	"./carousel/style/index.tsx": 1011,
	"./cascader/style/index.tsx": 1013,
	"./checkbox/style/index.tsx": 188,
	"./col/style/index.tsx": 1016,
	"./collapse/style/index.tsx": 1017,
	"./date-picker/style/index.tsx": 1019,
	"./divider/style/index.tsx": 1022,
	"./dropdown/style/index.tsx": 913,
	"./form/style/index.tsx": 1025,
	"./grid/style/index.tsx": 357,
	"./icon-svg/style/index.tsx": 1027,
	"./icon/style/index.tsx": 1029,
	"./input-number/style/index.tsx": 1030,
	"./input/style/index.tsx": 113,
	"./layout/style/index.tsx": 1032,
	"./list/style/index.tsx": 1034,
	"./locale-provider/style/index.tsx": 1038,
	"./mention/style/index.tsx": 1040,
	"./menu/style/index.tsx": 1042,
	"./message/style/index.tsx": 1045,
	"./modal/style/index.tsx": 1047,
	"./notification/style/index.tsx": 1049,
	"./pagination/style/index.tsx": 359,
	"./popconfirm/style/index.tsx": 1051,
	"./popover/style/index.tsx": 914,
	"./progress/style/index.tsx": 915,
	"./radio/style/index.tsx": 355,
	"./rate/style/index.tsx": 1054,
	"./row/style/index.tsx": 1056,
	"./select/style/index.tsx": 187,
	"./slider/style/index.tsx": 1057,
	"./spin/style/index.tsx": 358,
	"./steps/style/index.tsx": 1059,
	"./switch/style/index.tsx": 1061,
	"./table/style/index.tsx": 1063,
	"./tabs/style/index.tsx": 911,
	"./tag/style/index.tsx": 1065,
	"./time-picker/style/index.tsx": 912,
	"./timeline/style/index.tsx": 1067,
	"./tooltip/style/index.tsx": 353,
	"./transfer/style/index.tsx": 1069,
	"./tree-select/style/index.tsx": 1071,
	"./tree/style/index.tsx": 1073,
	"./upload/style/index.tsx": 1075,
	"./version/style/index.tsx": 1077
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 985;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 985
// module chunks = 1